(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService($uibModal) {
        var afterLogin;
        var service = {
            open: open
        };

        var modalInstance = null;

        var resetModal = function () {
            modalInstance = null;
            if (afterLogin)
                afterLogin();
        };

        return service;

        function open(then) {
            afterLogin = then;
            //
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
